module.exports = __webpack_public_path__ + "img/login_bg.cf258d47.png";